var _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1733923456789,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5123,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 460,
    fill: "#ffffff",
    "p-id": 5120
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 460,
    fill: "none",
    stroke: "#d9d9d9",
    strokeWidth: 20,
    "p-id": 5121
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 200,
    fill: "none",
    stroke: "#1890ff",
    strokeWidth: 40,
    "p-id": 5124
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 200,
    x2: 512,
    y2: 280,
    stroke: "#1890ff",
    strokeWidth: 40,
    strokeLinecap: "round",
    "p-id": 5125
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 744,
    x2: 512,
    y2: 824,
    stroke: "#1890ff",
    strokeWidth: 40,
    strokeLinecap: "round",
    "p-id": 5126
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 512,
    x2: 280,
    y2: 512,
    stroke: "#1890ff",
    strokeWidth: 40,
    strokeLinecap: "round",
    "p-id": 5127
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 744,
    y1: 512,
    x2: 824,
    y2: 512,
    stroke: "#1890ff",
    strokeWidth: 40,
    strokeLinecap: "round",
    "p-id": 5128
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 60,
    fill: "#1890ff",
    "p-id": 5129
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTarget);
export default __webpack_public_path__ + "static/media/location-target.27f4d58b235634cc2f225d6d6e5cda2d.svg";
export { ForwardRef as ReactComponent };